import { hotList, gossips } from "@/mocks/gossip";
import { SectionHeading } from "./SectionHeading";

const RANK_IMAGES: Record<number, string> = {
  1: "https://readdy.ai/api/search-image?query=coral%20red%20number%20one%20badge%20on%20warm%20paper%20texture%2C%20minimal%20editorial%20ranking%20concept%20abstract%20soft%20shadow&width=80&height=80&seq=r1&orientation=squarish",
  2: "https://readdy.ai/api/search-image?query=amber%20gold%20medal%20trophy%20on%20cream%20backdrop%2C%20minimal%20editorial%20second%20place%20ranking%20concept%20soft%20lighting&width=80&height=80&seq=r2&orientation=squarish",
  3: "https://readdy.ai/api/search-image?query=bronze%20tone%20geometric%20medal%20on%20warm%20background%2C%20minimal%20editorial%20third%20ranking%20concept%20abstract&width=80&height=80&seq=r3&orientation=squarish",
  4: "https://readdy.ai/api/search-image?query=teal%20abstract%20number%20four%20glowing%20on%20dark%20ink%20texture%2C%20editorial%20digital%20ranking%20concept%20soft%20gradient&width=80&height=80&seq=r4&orientation=squarish",
  5: "https://readdy.ai/api/search-image?query=warm%20neutral%20abstract%20waves%20with%20number%20five%20motif%2C%20minimal%20editorial%20ranking%20concept%20soft%20focus&width=80&height=80&seq=r5&orientation=squarish",
};

export default function HotRank() {
  const featured = gossips.slice(0, 1)[0];

  return (
    <section id="hot" className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20 lg:px-10">
      <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
        <SectionHeading
          kicker="热度榜单"
          title="此刻，全网都在围观什么"
          desc="综合全网讨论量、信源更新速度与搜索热度实时排序，只收录信源较完整、可追踪的事件。"
        />
        <div className="inline-flex items-center gap-2 text-xs text-foreground-500 whitespace-nowrap">
          <i className="ri-fire-line text-secondary-500"></i>
          每 10 分钟更新 · 数据截至今日
        </div>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-3">
        {/* featured left card */}
        <div className="lg:col-span-2">
          <a href="#timeline" className="group block overflow-hidden rounded-2xl border border-background-200 bg-background-100">
            <div className="relative aspect-[16/8] overflow-hidden">
              <img
                src={featured.image}
                alt="顶流演员片约风波完整存档主图"
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/70 to-transparent"></div>
              <div className="absolute bottom-4 left-4 flex items-center gap-2">
                <span className="rounded-full bg-primary-500 px-2.5 py-1 text-xs font-bold text-background-50">今日焦点</span>
                <span className="rounded-full bg-background-50/85 px-2.5 py-1 text-xs font-medium text-foreground-800 backdrop-blur-sm">
                  {featured.category}
                </span>
              </div>
            </div>
            <div className="p-5 md:p-6">
              <h3 className="font-heading text-lg font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-2xl">
                {featured.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{featured.excerpt}</p>
              <div className="mt-4 flex flex-wrap items-center gap-4 text-xs text-foreground-500">
                <span className="inline-flex items-center gap-1"><i className="ri-fire-line text-primary-500"></i>热度 {featured.heat}</span>
                <span className="inline-flex items-center gap-1"><i className="ri-time-line"></i>{featured.date}</span>
                <span className="inline-flex items-center gap-1"><i className="ri-book-open-line"></i>阅读约 {featured.read}</span>
                <span className="ml-auto inline-flex items-center gap-1 text-accent-600 group-hover:gap-2">
                  查看完整时间线 <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </div>
          </a>
        </div>

        {/* ranking list */}
        <div className="rounded-2xl border border-background-200 bg-background-100 p-3 md:p-4">
          <div className="flex items-center justify-between px-2 pb-3 pt-1">
            <h3 className="font-heading text-sm font-bold text-foreground-950">吃瓜热榜 TOP 10</h3>
            <span className="text-[11px] text-foreground-400 whitespace-nowrap">排序稳定 · 拒绝刷榜</span>
          </div>
          <ol className="space-y-1.5">
            {hotList.map((h) => {
              const img = RANK_IMAGES[h.rank] || RANK_IMAGES[5];
              return (
                <li key={h.rank}>
                  <a
                    href="#archive"
                    className="group flex items-center gap-3 rounded-xl px-2 py-2 transition-colors hover:bg-background-50"
                  >
                    <div className="relative h-10 w-10 shrink-0 overflow-hidden rounded-lg">
                      <img src={img} alt={""} className="h-full w-full object-cover" loading="lazy" />
                      <span className="absolute inset-0 flex items-center justify-center bg-foreground-950/35 text-xs font-black text-background-50">
                        {h.rank}
                      </span>
                    </div>
                    <div className="min-w-0 flex-1">
                      <p className="truncate text-sm font-medium text-foreground-800 group-hover:text-primary-700">
                        {h.title}
                      </p>
                      <p className="mt-0.5 text-[11px] text-foreground-400">{h.category}</p>
                    </div>
                    <div className="flex shrink-0 flex-col items-end">
                      <span className="inline-flex items-center gap-1 text-xs font-semibold text-primary-600">
                        <i className={h.up ? "ri-arrow-up-line" : "ri-arrow-down-line"}></i>
                        {h.heat}
                      </span>
                      <span className="text-[10px] text-foreground-400">热度</span>
                    </div>
                  </a>
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </section>
  );
}